import { Component, OnInit } from '@angular/core';
import { ComponentBaseComponent } from '@app/core/components/component-base/component-base.component';
import { Grid } from '@app/core/components/grid/grid.model';
import { GridOptions } from '@app/core/components/grid/grid.types';
import { DataTaskService } from '@app/core/services/data-task.service';
import { ModalService } from '@app/core/services/modal.service';
import { StateService } from '@app/core/services/state.service';

@Component({
    selector: 'tt-order-purch',
    templateUrl: './order-purch.component.html',
    styleUrls: ['./order-purch.component.css'],
})
export class OrderPurchComponent extends ComponentBaseComponent implements OnInit {
    private orderInternalNo = '';

    public get?: any;

    public deliveryAddresses: any[] = [];

    public displayTypes: any[] = [];

    public selectedTab: string = 'STATUS';

    public statusGrid?: GridOptions;

    public purchheadsGrid?: GridOptions;

    constructor(private datatask: DataTaskService, private modal: ModalService, state: StateService) {
        super();
        this.orderInternalNo = state.getStateParams()['order_internal_no'];
    }

    private createPurchaseOrders = async () => {
        if (!!this.statusGrid) {
            const rows = this.statusGrid.gridfunc?.getIsSelectedRows() ?? [];

            if (rows.length > 0) {
                try {
                    this.statusGrid.gridfunc?.gridProgress(true);

                    const response = (await this.datatask.Post(998, { ...Object.assign({}, this.get), records: rows }))[0];

                    if (!!response && 'errormessage' in response && typeof response.errormessage === 'string' && !!response.errormessage.trim()) {
                        this.modal.show({ type: 'warning', title: 'error', translateTitle: true, message: response.errormessage });
                    }
                } finally {
                    this.statusGrid.gridfunc?.read();
                }
            }
        }
    };

    public readGrid() {
        if (this.selectedTab === 'STATUS') {
            if (!this.statusGrid) {
                this.createStatusGrid();
            } else {
                this.statusGrid.gridfunc?.read();
            }
        } else if (this.selectedTab === 'PURCHORDERS') {
            if (!this.purchheadsGrid) {
                this.createPurchheadsGrid();
            } else {
                this.purchheadsGrid.gridfunc?.read();
            }
        }
    }

    private createStatusGrid() {
        if (!!this.get) {
            this.statusGrid = new Grid()
                .setRememberId('w_orderpurch.grid')
                .setLoadDataFunction({ method: 3716, parameters: () => this.get })
                .setCustomToolbarButtons([{ name: 'orderpurch_create_purchaseorders', text: 'orderpurch_create_purchaseorders', translate: true, icon: 'fas fa-sync-alt', cssClass: 'tt-button tt-button--primary im-grid-btn-xs-l', spinOnAction: true, func: this.createPurchaseOrders, disable_if_no_selected: true }]);
        }
    }

    private createPurchheadsGrid() {
        if (!!this.get) {
            this.purchheadsGrid = new Grid().setRememberId('w_orderpurch.purcheadgrid').setLoadDataFunction({ method: 3721, parameters: () => this.get });
        }
    }

    private async loadDeliveryAddresses() {
        this.deliveryAddresses = await this.datatask.Post(994);
    }

    private async loadDisplayTypes() {
        this.displayTypes = await this.datatask.Post(996);
    }

    private async loadGet() {
        this.get = (await this.datatask.Post(993, { order_internal_no: this.orderInternalNo }))[0];
        // this.get = (await this.datatask.Post(993, { order_internal_no: '643800' }))[0];
        // this.get = (await this.datatask.Post(993, { order_internal_no: '624100' }))[0];
    }

    async ngOnInit(): Promise<void> {
        this.loadDeliveryAddresses();
        this.loadDisplayTypes();
        await this.loadGet();
        this.readGrid();
    }
}
